import { Grid, TableCell } from "@mui/material";
import React, { useContext } from "react";
import { Table } from "../../../layout";
import { connect } from "react-redux";
import { useEffect } from "react";
import { AppContext } from "../../../App";
import { controller, endpoints } from "../../../api/actions/api";
import * as actions from "../../../api/actions/actions";
import { useState } from "react";
import RepNav from "./RepNav";
import moment from "moment";

const Ledger = (props) => {
  const { _getById, _hoa } = props;
  const [ap, setAp] = useState([]);
  const [ar, setAr] = useState([]);
  const [filteredAp, setFilteredAp] = useState([]);
  const [filteredAr, setFilteredAr] = useState([]);
  const [apTblData, setApTblData] = useState([]);
  const [arTblData, setArTblData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [csvHeader, setCsvHeader] = useState([]);
  const [cats, setCats] = useState([]);
  const [sortDate, setSortDate] = useState({
    fromDate: `1/1/${new Date().getFullYear()}`,
    toDate: `12/31/${new Date().getFullYear()}`,
  });
  const { setLoader } = useContext(AppContext);

  useEffect(() => {
    setCsvHeader([
      { label: "Date", key: "date" },
      { label: "Description", key: "desc" },
      { label: "Category", key: "cat" },
      { label: "Credit", key: "credit" },
      { label: "Debit", key: "debit" },
    ]);
    return () => {
      setCsvHeader([]);
    };
  }, []);

  useEffect(() => {
    if (arTblData || apTblData) {
      var totalCredit = arTblData
        .map((j) => j.credit)
        .reduce((x, y) => x + y, 0);

      var totalDebit = apTblData.map((j) => j.debit).reduce((x, y) => x + y, 0);

      setCsvData([
        ...arTblData,
        {
          date: "Total Income",
          desc: "",
          cat: "",
          credit: totalCredit.toLocaleString(),
        },
        {},
        {},
        ...apTblData,
        {
          date: "Total Expense",
          desc: "",
          cat: "",
          credit: "",
          debit: totalDebit.toLocaleString(),
        },
        {
          date: "Balance (Income - Expense)",
          desc: "",
          cat: "",
          credit: "",
          debit: (totalCredit - totalDebit).toLocaleString(),
        },
      ]);
    }

    return () => {};
  }, [arTblData, apTblData]);

  useEffect(() => {
    if (ap || ar) {
      setFilteredAp([
        ...ap.filter(
          (j) =>
            moment(j.paidDate, "MM/DD/YYYY") >=
              moment(sortDate.fromDate, "MM/DD/YYYY") &&
            moment(j.paidDate, "MM/DD/YYYY") <=
              moment(sortDate.toDate, "MM/DD/YYYY")
        ),
      ]);
      setFilteredAr([
        ...ar.filter(
          (j) =>
            moment(j.dueDate, "MM/DD/YYYY") >=
              moment(sortDate.fromDate, "MM/DD/YYYY") &&
            moment(j.dueDate, "MM/DD/YYYY") <=
              moment(sortDate.toDate, "MM/DD/YYYY")
        ),
      ]);
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ap, ar, sortDate]);

  useEffect(() => {
    if (_hoa.id) {
      setLoader(true);

      _getById(endpoints.AP + controller.GetByHoa, _hoa.id, null, (res) => {
        setLoader(false);
        res.status === 200 &&
          setAp([...res.result.filter((j) => j.isComplete)]);
      });

      _getById(
        endpoints.Invoice + controller.GetByHoa,
        _hoa.id,
        null,
        (res) =>
          res.status === 200 &&
          setAr([
            ...res.result.filter((j) => j.invPayments.some((x) => x.paidAmt)),
          ])
      );

      _getById(
        endpoints.HoaCat + controller.GetByHoa,
        _hoa.id,
        null,
        (res) => res.status === 200 && setCats([...res.result])
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_hoa]);

  useEffect(() => {
    if (filteredAr) {
      setArTblData([
        ...filteredAr.map((j) => {
          var lastPay = j.invPayments.slice(-1).pop();
          return {
            date: lastPay && lastPay.paidDate,
            desc: j.descr,
            cat: j.category.name,
            credit: j.invPayments
              .map(
                (x) =>
                  x.paidAmt +
                  x.invLateFees.map((y) => y.paidAmt).reduce((x, y) => x + y, 0)
              )
              .reduce((x, y) => x + y, 0),
          };
        }),
      ]);
    }

    return () => {
      setArTblData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredAr, cats]);

  useEffect(() => {
    if (filteredAp) {
      setApTblData([
        ...filteredAp.map((j) => {
          return {
            date: j.paidDate,
            desc: j.descr,
            cat: j.category.name,
            debit: j.amount,
          };
        }),
      ]);
    }

    return () => {
      setApTblData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredAp, cats]);

  const IncHeader = () => (
    <div className="d-flex a-center flex-wrap">
      <h2 className="border-left h fw-4 fs-16 gray-color tx-upp">Income</h2>
    </div>
  );
  const ExpHeader = () => (
    <div className="d-flex a-center flex-wrap">
      <h2 className="border-left h fw-4 fs-16 gray-color tx-upp">Expenses</h2>
    </div>
  );
  return (
    <Grid container spacing={3} className="pt-15">
      <Grid item xs={12} className="pb-30">
        <RepNav
          {...{
            csvHeader,
            csvData,
            sortDate,
            setSortDate,
            title: "General Leadger",
          }}
        />
      </Grid>

      {/* Income  */}
      <Grid item xs={12} md={6}>
        <Table
          shadow={false}
          showSearch={false}
          ActionComp={() => <></>}
          HeaderComp={IncHeader}
          tblHead={[
            { id: "date", label: "Date" },
            { id: "desc", label: "Description" },
            { id: "cat", label: "Category" },
            { id: "credit", label: "Credit" },
          ]}
          tblData={arTblData.map((j) => {
            return {
              ...j,
              credit: "$ " + j.credit.toLocaleString(),
            };
          })}
          FooterRow={() => (
            <>
              <TableCell className="gray-color fw-6 fs-italic fs-16">
                Total
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell className="gray-color fw-6 fs-italic fs-16">
                ${" "}
                {arTblData
                  .map((j) => j.credit)
                  .reduce((x, y) => x + y, 0)
                  .toLocaleString()}
              </TableCell>
            </>
          )}
        />
      </Grid>

      {/* Expenses */}
      <Grid item xs={12} md={6}>
        <Table
          shadow={false}
          ActionComp={() => <></>}
          showSearch={false}
          HeaderComp={ExpHeader}
          tblHead={[
            { id: "date", label: "Date" },
            { id: "desc", label: "Description" },
            { id: "cat", label: "Category" },
            { id: "debit", label: "Debit" },
          ]}
          tblData={apTblData.map((j) => {
            return {
              ...j,
              debit: "$ " + j.debit.toLocaleString(),
            };
          })}
          FooterRow={() => (
            <>
              <TableCell className="gray-color fw-6 fs-italic fs-16">
                Total
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell className="gray-color fw-6 fs-italic fs-16">
                ${" "}
                {apTblData
                  .map((j) => j.debit)
                  .reduce((x, y) => x + y, 0)
                  .toLocaleString()}
              </TableCell>
            </>
          )}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  _hoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
};

export default connect(mapStateToProps, mapActionToProps)(Ledger);
